import { render } from "./ContactosPage.vue?vue&type=template&id=be34b91e"
import script from "./ContactosPage.vue?vue&type=script&lang=js"
export * from "./ContactosPage.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__